export const roles = {
  Admin: 'Admin',
  Recruiter: 'Recruiter',
  HiringManager: 'HiringManager',
  SuperAdmin: 'SuperAdmin',
} as const;

export type Role = (typeof roles)[keyof typeof roles];

export const availableRoles = Object.values(roles);
